<template>
  <div class="mt-3">
    <!-- เปิดคลัง -->
    <div v-if="$parent.wmsService == 2 && warehouseLists.length > 0">
      <div>
        <div class="row fw-bold">
          <div class="col-10 font-weight-bold" data-test="text-warehouse">
            {{ $t("Warehouses") }}
          </div>
          <div
            class="col-2 font-weight-bold text-right"
            data-test="text-available"
          >
            {{ $t("_Stock.Available") }}
          </div>
        </div>
        <div
          v-for="(item, index) in warehouseLists"
          :key="item.id"
          class="row my-1 h-35"
          :class="{
            'mb-2': item.specific_warehouse
          }"
        >
          <div
            class="col-9 pl-4 text-left"
            data-test="data-warehouse"
            :class="{
              'd-flex align-items-center': !item.specific_warehouse
            }"
          >
            {{ item.warehouse }}
            <p
              class="font-size-xs mt-1 text-muted"
              v-if="item.specific_warehouse"
            >
              {{
                $t(
                  "Modifying the stock quantity in this warehouse will affect the inventory of connected stores."
                )
              }}
            </p>
          </div>

          <div
            class="col-3 text-right d-flex justify-content-end"
            :class="{
              'align-items-center': !item.specific_warehouse
            }"
          >
            <div v-if="editIndex === index">
              <vue-numeric-input
                :ref="'numericInput' + index"
                :type="'text'"
                v-model="item.available_qty"
                controls-type="updown"
                :min="0"
                :max="9999999"
                :step="1"
                :precision="2"
                class="numeric-input text-right"
                @input="updateValue($event, index)"
                @keyup.enter="saveEdit"
                @blur="handleBlur"
                align="center"
                data-test="input-stock"
              />
            </div>
            <div
              v-else
              class="btn-link font-weight-bold pointer edit-button"
              @click="startEdit(index)"
              data-test="click-text-edit-stock"
            >
              <div class="align-items-center d-flex ">
                <div class="font-size-16 d-flex align-items-center">
                  {{ item.available_qty | formatNumberNotZero }}
                </div>
                <a class="ml-1 d-flex align-items-center">
                  <span>
                    <i
                      class="fa-solid fa-pen-square"
                      style="font-size: 18px;margin-top: 4px;"
                    ></i>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row border-bottom border-top py-2">
        <div
          class="col-4 d-flex align-items-center font-weight-bold justify-content-start"
          data-test="text-available-all"
        >
          {{ $t("_Stock.Available All") }}
        </div>

        <div
          class="col-8 d-flex align-items-center justify-content-end font-size-16"
        >
          <p v-if="availableCurrent !== totalAvailable" class="mb-0">
            <span
              class="text-decoration-line-through text-muted"
              data-test="text-available-current"
            >
              {{ availableCurrent | formatNumberNotZero }}
            </span>
            <i class="fa-solid fa-arrow-right"></i>
            <span
              :class="
                availableCurrent < totalAvailable
                  ? 'text-success'
                  : 'text-warning'
              "
              data-test="total-available"
            >
              {{ totalAvailable | formatNumberNotZero }}
            </span>
          </p>
          <p v-else class="mb-0" data-test="total-available">
            {{ totalAvailable | formatNumberNotZero }}
          </p>
        </div>
      </div>

      <div class="row border-bottom py-1" data-test="section-reserved">
        <div class="col-9">
          <p class="font-weight-bold mb-1" data-test="text-reserved">
            {{ $t("_Stock.Reserved") }}
          </p>
          <label
            class="font-size-xs text-muted"
            data-test="description-reserved"
          >
            {{
              $t(
                "The reservation quantity may change due to various situations, such as order creation, order cancellation, or stock transfer."
              )
            }}
            <span
              v-if="reserve > 0"
              @click="$parent.switchPage('reserved')"
              class="text-underline btn-link pointer "
              data-test="btn-view-reserved"
              >{{ $t("View Reserved") }}</span
            >
          </label>
        </div>
        <div class="col-3 text-right font-size-16" data-test="data-reserved">
          <p>{{ reserve | formatNumberNotZero }}</p>
        </div>
      </div>

      <div class="row border-bottom py-1" v-if="restock && restock > 0">
        <div class="col-9">
          <p class="font-weight-bold mb-1" data-test="text-re-stock">
            {{ $t("Pending Issue (Re-Stock)") }}
          </p>
          <label
            class="font-size-xs text-muted"
            data-test="description-re-stock"
          >
            {{
              $t(
                "The item quantity was shipped without updating (deducting) the stock"
              )
            }}
          </label>
        </div>
        <div class="col-3 text-right font-size-16" data-test="data-re-stock">
          <p>{{ restock | formatNumberNotZero }}</p>
        </div>
      </div>

      <div class="row py-1" data-test="section-salable">
        <div
          class="h-32 align-items-center col-4 d-flex font-weight-bold justify-content-start font-weight-bold"
          data-test="text-salable"
        >
          {{ $t("_Stock.Salable") }}
        </div>
        <div
          class="h-32 col-8 d-flex align-items-center justify-content-end font-size-16"
        >
          <p v-if="salableCurrent !== salable" class="m-0">
            <span
              class="text-decoration-line-through text-muted"
              data-test="text-salable-current"
              >{{ salableCurrent | formatNumberNotZero }}</span
            >

            <i class="fa-solid fa-arrow-right"></i>
            <span
              :class="
                salableCurrent < salable ? 'text-success' : 'text-warning'
              "
              data-test="data-salable"
            >
              {{ salable | formatNumberNotZero }}
            </span>
          </p>
          <p v-else class="m-0" data-test="data-salable">
            {{ salable | formatNumberNotZero }}
          </p>
        </div>
      </div>
    </div>
    <!-- ไม่เปิดคลัง -->
    <div v-else class="row py-1 " data-test="section-salable">
      <div
        class="align-items-center col-9 d-flex font-weight-bold justify-content-start font-weight-bold"
        data-test="text-salable"
      >
        {{ $t("_Stock.Salable") }}
      </div>
      <div class="col-3 font-size-16 text-right">
        <vue-numeric-input
          :type="'text'"
          ref="edit_salable"
          v-model.number="$parent.editSalable"
          controls-type="updown"
          :max="9999999"
          :step="1"
          :precision="2"
          class="numeric-input text-right"
          align="center"
          data-test="input-salable"
          @input="onSalableInput"
        />
        <p
          v-if="$parent.$v.editSalable.$invalid"
          class="validation-invalid-label position-absolute text-nowrap"
          v-html="$t('Maximum value limit 9,999,999.')"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Select2 from "v-select2-component";
import numeral from "numeral";
import VueNumericInput from "vue-numeric-input";

export default {
  components: {
    Select2,
    VueNumericInput
  },
  props: {
    warehouseLists_: {
      type: [Object, Array],
      default: undefined
    },
    reserve_: {
      type: [String, Number],
      default: 0
    },
    restock_: {
      type: [String, Number],
      default: 0
    }
  },
  data() {
    return {
      warehouseLists: this.warehouseLists_,
      reserve: this.reserve_,
      restock: this.restock_,
      editIndex: null,
      oldAvailableQty: null,
      salableCurrent: 0,
      availableCurrent: 0,
      autoFocus: false
    };
  },
  filters: {
    formatNumberNotZero: function(value) {
      return numeral(value).format("0,0");
    }
  },
  async created() {},
  methods: {
    startEdit(index) {
      this.editIndex = index;

      this.$nextTick(() => {
        const refName = "numericInput" + index;
        const inputComponent = this.$refs[refName] && this.$refs[refName][0];
        if (inputComponent && inputComponent.$el) {
          const input = inputComponent.$el.querySelector("input");
          if (input) input.focus();
        }
      });
    },
    saveEdit() {
      this.editIndex = null;
    },
    handleBlur() {
      setTimeout(() => {
        const refName = "numericInput" + this.editIndex;
        const numericInputComponent = this.$refs[refName][0];
        const active = document.activeElement;

        const container = numericInputComponent && numericInputComponent.$el;

        if (!container || !container.contains(active)) {
          this.saveEdit();
        }
      }, 150);
    },
    updateValue(value, index) {
      this.warehouseLists[index].available_qty = isNaN(value) ? 0 : value;
    },
    handleClickOutside(event) {
      if (this.editIndex === null) return;

      const refName = "numericInput" + this.editIndex;
      const numericInputComponent =
        this.$refs[refName] && this.$refs[refName][0];
      if (!numericInputComponent || !numericInputComponent.$el) return;

      const inputEl = numericInputComponent.$el;

      if (inputEl.contains(event.target)) return;

      this.saveEdit();
    },
    onSalableInput(value) {
      if (value === '' || value === null || isNaN(value)) {
        this.$parent.editSalable = 0;
        this.$refs.edit_salable.numericValue = 0;
      } else {
        this.$parent.editSalable = value;
      }
    }
  },
  mounted() {
    this.availableCurrent = Number(this.totalAvailable || 0);
    const reserve = Number(this.reserve || 0);
    const restock = Number(this.restock || 0);

    this.salableCurrent = this.availableCurrent - (reserve + restock);
    if (this.warehouseLists.length > 0) {
      document.addEventListener("mousedown", this.handleClickOutside);
    }
  },
  computed: {
    totalAvailable() {
      const specificItems = this.warehouseLists.filter(
        item => item.specific_warehouse
      );
      if (specificItems.length === 1) {
        return specificItems[0].available_qty;
      }
      return this.warehouseLists.reduce(
        (sum, item) => sum + Number(item.available_qty),
        0
      );
    },
    salable() {
      const available = Number(this.totalAvailable || 0);
      const reserve = Number(this.reserve || 0);
      const restock = Number(this.restock || 0);

      const salable = available - (reserve + restock)

      if (this.$parent.wmsService == 2 && this.warehouseLists.length > 0) {
        this.$parent.editSalable = salable
      }

      return salable;
    },
  },
  watch: {
    salable(newValue) {
      this.$emit('update-salable', newValue);
    }
  },
  filters: {
    formatNumber: function(value) {
      return numeral(value).format("0,0.00");
    },
    formatNumberNotZero(value) {
      return numeral(value).format("0,0");
    }
  },
  beforeDestroy() {
    if (this.warehouseLists.length > 0) {
      document.removeEventListener("mousedown", this.handleClickOutside);
    }
  }
};
</script>

<style scoped>
.fade {
  pointer-events: none !important;
}
.modal + .modal.modal-update-salable {
  z-index: 1099;
}
.h-35 {
  height: 35px;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/stock/UpdateSalable.vue